// default code updated with DOMSubtreeModified error

//var mcp_option_hide_class = ".product-form__input"
var mcp_option_hide_class='.product-form__input,.product-options,.product-options--option,.product__option,.product-variant-picker-block,.product-option,.wetheme-dropdown__select,.product-variant,.variant-wrapper,.swatch selectors,.option-selector,.selector-wrapper,.ProductForm__Option,.product-form__swatch,.form-field-swatch,.swatch,.single-option-selector,.selected-text,.product-form__option-selector,.swatches__container,.radios--root,.options-selection__select-wrapper,.item,.option-selector-fieldset,.swatches-wrapper,.product-details__option-wrapper,.form-row,.js-variant-selector,.product__section--element,.product-form__item,.radio-wrapper'
//var cartclass = ".product-option"
var cartclass=".cart-notification-product__options,.product-option,.line-item-options,.ajax-cart__cart-variants,.quick-cart__item-middle,.cart__meta-text,.cart__item--variants,.cart-item__selected-options,.description__variant,.cart__item__meta,.cart-product__content__meta,.meta,.cart-variant__item,.product-details__item,.product-details__item--variant-option"
//var neglectAnchors = ".cart-notification"
var neglectAnchors='.product__info-wrapper,.cart-notification,.product-quickview__form-wrapper,.cart-dropdown,.cart-product,.quickbuy,.modal--quick-shop,.Drawer__Content,.cart-drawer,.drawer__content,.side-cart,.product-container--quickbuy,.cart-summary,.sidebar__cart,.mini-cart-item-wrapper,.drawer--quick-buy,.drawer,.product__quickview-wrapper,.ajax-cart__drawer-wrapper,.off-canvas--container,.product-quickshop__container,.quickbuy-container,.cart-summary-overlay,.mini-cart__container,.quickbuy-form,.cart-drawer-form,.product__wrapper,.ajax-cart__cart-form,.js-cart-form,.cart-form,.ajaxcart'
// var isSaleClass = true
// var saleClass = ".card__badge"
var saleClass='.label,.sale-item,.card__badge,.sale-badge,.icon-type--sale-item,.tw-bg-price-sale,.grid-product__tag--sale,.sale-box,.product-label--on-sale,.product-grid-on-sale,.ProductItem__Label--onSale,.is-sale,.product-card__label--sale,.product--label,.sale,.product-thumbnail__product-sticker--sale,.price-label--sale,.productlabel,.envy-badge,.product-item__badge--sale,.sale_banner,.badge--sale,.price__badge--sale,.product-tag,.product-item__badge'
// var isSaveAmount = false
// var saveAmountClass = "."

var saveAmountClass='.product__badge--sale,.product-loop__price--savings,.grid-product__price--savings,.product-label--on-sale,.badge,.grid-product__tag--sale,.label,.label--highlight,.sale-item--amount,.sale-tag,.grid-product__on-sale'
// var isSalePercentage = false
// var salePercentageClass = "."
var salePercentageClass='.product--label,.product-item-banners,.product__badge__item--saving,.product__badge--sale,.sale,.product-label--sale,.product-item__badge--sale,.sale-item--percentage,.product-block__sale-label'
//var isTextWithPrice = false
var textWithPrice = "On Sale,Now"
var priceColor = ""
var moneyNeglectClass = "."
var divInputClass = "."
var saleClasses='.icon-type--sale-item,.product-item__badge--sale,.product-label--on-sale,.product-thumbnail__product-sticker--sale,.sale,.product__badge__item--saving,.product-block__sale-label,.tw-bg-price-sale,.card__badge,.productlabel,.sale-badge,.badge--sale,.sale-item--percentage,.ProductItem__Label--onSale,.product-card__label--sale,.product__badge--sale,.sale-item--amount,.grid-product__tag--sale,.sale-tag,.label--highlight,.product-tag,.product-item-banners,.sale-box,.grid-product__on-sale,.badge,.product--label,.sale_banner,.price__badge--sale,.grid-product__price--savings,.product-grid-on-sale,.product-label--sale,.product-item__badge,.envy-badge,.product-loop__price--savings,.price-label--sale,.label,.is-sale'
//var saleArray = ['.icon-type--sale-item', '.product-item__badge--sale', '.product-label--on-sale', '.product-thumbnail__product-sticker--sale', '.sale', '.product__badge__item--saving', '.product-block__sale-label', '.tw-bg-price-sale', '.card__badge', '.productlabel', '.sale-badge', '.badge--sale', '.sale-item--percentage', '.ProductItem__Label--onSale', '.product-card__label--sale', '.product__badge--sale', '.sale-item--amount', '.grid-product__tag--sale', '.sale-tag', '.label--highlight', '.product-tag', '.product-item-banners', '.sale-box', '.grid-product__on-sale', '.badge', '.product--label', '.sale_banner', '.price__badge--sale', '.grid-product__price--savings', '.product-grid-on-sale', '.product-label--sale', '.product-item__badge', '.envy-badge', '.product-loop__price--savings', '.price-label--sale', '.label', '.is-sale']


var queryParameterRegex = /\?.+=.*/g;

if ( neglectAnchors == '.' ) {
	neglectAnchors = 'a'
}

var moneyNeglect = ""

if ( moneyNeglectClass != '.' ) {
  for ( let i = 0; i < moneyNeglectClass.split(',').length; i++ ) {
    if(i==0){
        if(moneyNeglect != ""){
            moneyNeglect += ', '+ moneyNeglectClass.split(',')[0] + ' .money'
        }
        else{
         moneyNeglect += moneyNeglectClass.split(',')[0] + ' .money'
        }
    }
    else{
    moneyNeglect += ', ' + moneyNeglectClass.split(',')[i] + ' .money'
  }
  }
}


var appendStoreCurrency = ["collections","search","products"];

var myURLarray = ["collections","search"];


var mlveda_condition_flag_select = false;
var mlveda_condition_flag_input = false;
var convert_currency = false;
var first_call = false
var flag_for_updateprice = true
var ul_class = ""
var element_of_structure = ""
// if ( element_of_structure == "div ." ) {
//   element_of_structure = "fieldset"
// }

// MLveda.formatMoney
"undefined"==typeof Mlveda&&(Mlveda={}),Mlveda.formatMoney||(Mlveda.formatMoney=function(a,e){function t(a,e){return void 0===a?e:a}function r(a,e,r,o){if(e=t(e,2),r=t(r,","),o=t(o,"."),isNaN(a)||null==a)return 0;var n=(a=(a/100).toFixed(e)).split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+r)+(n[1]?o+n[1]:"")}"string"==typeof a&&(a=a.replace(".",""));var o="",n=/\{\{\s*(\w+)\s*\}\}/,s=e;switch(s.match(n)[1]){case"amount":o=r(a,2);break;case"amount_no_decimals":o=r(a,0);break;case"amount_with_comma_separator":o=r(a,2,".",",");break;case"amount_with_space_separator":o=r(a,2," ",",");break;case"amount_with_period_and_space_separator":o=r(a,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=r(a,0,".",",");break;case"amount_no_decimals_with_space_separator":o=r(a,0," ");break;case"amount_with_apostrophe_separator":o=r(a,2,"'",".")}return s.replace(n,o)}); 

function remove_mlveda() {
  if ( cartclass != '.' ) {
	document.querySelectorAll(cartclass).forEach(
		(e) => {if (e.innerHTML != null && mlveda_regex.test(e.innerHTML) ) {
			e.innerHTML = e.innerHTML.replace(mlveda_regex, "")
		}
	})
  }
}

function mlveda_country_hide() {
  document.querySelectorAll(mcp_option_hide_class).forEach((element) => {
    if ( element.style.display != 'none' && element.textContent.toLowerCase().trim().indexOf('mlveda_country') != -1 ) {
      element.setAttribute('style', 'display: none !important')
      if ( element.querySelectorAll('[data-value]').length > 0 && element.querySelectorAll('[value]').length == 0 && ul_class == '' ) {
        if ( element.nodeName == "UL" ) {
          element.classList.forEach((classname) => {
            if ( ul_class == '' && mcp_option_hide_class.indexOf(classname) != -1 ) {
              ul_class = '.' + classname
            }
          })
        } else if ( element.querySelectorAll('ul').length > 0 ) {
          ul_class = "." + element.querySelectorAll('ul')[0].classList[0]
        }
      } else if ( element.querySelectorAll('input').length > 0 && element_of_structure == '' ) {
        element.classList.forEach((classname) => {
          if ( element_of_structure == '' && mcp_option_hide_class.indexOf(classname) != -1 ) {
            element_of_structure = '.' + classname
          }
        })
      }
    } else if (element.style.display != 'none' && (($m(element).find("[value]").length != 0 && Array.from($m(element).find("[value]")).every(currentValue => {return String(currentValue.value).match(pattern)})) || ($m(element).find("[data-value]").length != 0 && Array.from($m(element).find("[data-value]")).every(currentValue => {return String($m(currentValue).data('value')).match(pattern)}))) ) {
      element.setAttribute('style', 'display: none !important')
      if ( element.textContent.toLowerCase().indexOf('mlveda_country') == -1 && element.parentElement.textContent.toLowerCase().indexOf('mlveda_country') != -1 ) {
        let all_elements = $m(element.parentElement).find(':contains(mlveda_country)')
        if ( all_elements[all_elements.length - 1].style.display != 'none' ) {
          all_elements[all_elements.length - 1].setAttribute('style', 'display: none !important')
        }
      }
    }
  })
}

// document.addEventListener('DOMSubtreeModified', mlveda_country_hide)
const mutationCallback = function (mutationsList, observer) {
  mutationsList.forEach((mutation) => {
    try {
      mlveda_country_hide();
    } catch (err) {
      console.log("error", err);
    }
  });
};

if (document.body) {
  const observer = new MutationObserver(mutationCallback);

  const observerOptions = {
    childList: true,
    subtree: true,
  };

  observer.observe(document.body, observerOptions);
} else {
  document.addEventListener("DOMContentLoaded", () => {
    const observer = new MutationObserver(mutationCallback);

    const observerOptions = {
      childList: true,
      subtree: true,
    };

    observer.observe(document.body, observerOptions);
  });
}


 $m("<style type='text/css'>"+ saleClasses+"{ visibility : hidden; }</style>").appendTo("head");

 //var structure_type = ''
//  function detect_structure() {
//   if ( structure_type == '' ) {
//    document.body.querySelectorAll('select').forEach(element => {
//      if ( element.querySelectorAll('[value]').length > 0 && Array.from(element.querySelectorAll('[value]')).every(currentValue => { return currentValue.value.match(pattern) }) ) {
//        structure_type = 'selectbox'
//      }
//    })
   
//    if ( structure_type === '' ) {
//      let mattched = Array.from(document.body.querySelectorAll('input')).filter(element => element.value.match(pattern))
//      if ( mattched.length > 0 ) {
//      let found_common_parrent = false
//      let common_parent = mattched[0].parentElement
//      while ( !found_common_parrent ) {
//          if ( common_parent.querySelectorAll('input').length === mattched.length && common_parent.textContent.indexOf('mlveda_country') != -1 ) {
//              found_common_parrent = true
//          } else {
//              common_parent = common_parent.parentElement
//          }
//      }
//       structure_type = 'input-element'
//      }
//    }
//   }
//  }


 if("undefined" == typeof HTMLSelectElement.prototype.realAddEventListener){
  HTMLSelectElement.prototype.realAddEventListener = HTMLSelectElement.prototype.addEventListener;
  }
  HTMLSelectElement.prototype.addEventListener = function(a,b,c){ 
    this.realAddEventListener(a,b,c);
  // console.log(this) 
      if(!window.lastSelectListenerInfo){window.lastSelectListenerInfo = new Array()};
  // console.log(a);
    if(a == "change" && this.getAttribute("name") != "id"){
  // console.log(a);
  // console.log(options)
      var mlveda_selectbox_flag = Array.from(this.children).every((currentValue) => { return pattern.test(currentValue.value.trim()) })
        if(mlveda_selectbox_flag){
          window.lastSelectListenerInfo.push({a : a, b : b , c : c});
      }
      }
  };
  
  if("undefined" == typeof HTMLInputElement.prototype.realAddEventListener){
    HTMLInputElement.prototype.realAddEventListener = HTMLInputElement.prototype.addEventListener;
    }
    
    HTMLInputElement.prototype.addEventListener = function(a,b,c){ 
    // console.log(this);
    // console.log()
        this.realAddEventListener(a,b,c); 
        if(!window.lastInputListenerInfo){  window.lastInputListenerInfo = new Array()};
      if(a == "change" && this.getAttribute("name") != "id" && pattern.test(this.value)){
        if ( this.parentElement != null ) {
        var mlveda_selectbox_flag = false;
        
        var allinputs = Array.from(this.parentElement.querySelectorAll(this.nodeName.toLowerCase()));	
    //       console.log(allinputs,this);  
          if(allinputs.length == 1){
        allinputs = Array.from(this.parentElement.parentElement.querySelectorAll(this.nodeName.toLowerCase()));	
          }
          if(allinputs.length > 1){
        mlveda_selectbox_flag = allinputs.every((currentValue) => { return pattern.test(currentValue.value.trim()) })
          if(mlveda_selectbox_flag && lastInputListenerInfo.length == 0){
          window.lastInputListenerInfo.push({a : a, b : b , c : c});
          }
          }
        } else {
          if(lastInputListenerInfo.length == 0){
            window.lastInputListenerInfo.push({a : a, b : b , c : c});
            }
        } 
        }
    };

  if("undefined" == typeof HTMLFormElement.prototype.realAddEventListener){
  HTMLFormElement.prototype.realAddEventListener = HTMLFormElement.prototype.addEventListener;
  }
  HTMLFormElement.prototype.addEventListener = function(a,b,c){ 
      this.realAddEventListener(a,b,c); 
      if(!window.lastFormListenerInfo){  window.lastFormListenerInfo = new Array()};
      if(a == "change" && this.getAttribute("action") && this.getAttribute("action").indexOf("/cart/add") != 1){
      window.lastFormListenerInfo.push({a : a, b : b , c : c});
    //console.log("inside form element");
    }
  };

  
  // if("undefined" == typeof HTMLDivElement.prototype.realAddEventListener){
  //   HTMLDivElement.prototype.realAddEventListener = HTMLDivElement.prototype.addEventListener;
  // }
  
  // HTMLDivElement.prototype.addEventListener = function(a,b,c){ 
  //     this.realAddEventListener(a,b,c); 
  //     if(!window.lastListenerInfo){  window.lastListenerInfo = new Array()};
  //   if(a.indexOf("change") != -1 && this.getAttribute("name") != "id" && pattern.test(this.value)){
  //       if( lastListenerInfo.length == 0){
  //       window.lastListenerInfo.push({a : a, b : b , c : c});
  //       }
  
  //     }
  // };


var mlveda_observer = new MutationObserver(function(mutations){
			//console.log(mutations.length);

 // detect_structure()
  
			mutations.forEach(function(mutation) {
		
        if ( "undefined" != typeof mlvedaFlagCalled && mlvedaFlagCalled && "undefined" != typeof window.mlvedadefaultcurrency && window.mlvedadefaultcurrency && ACSCurrency.currentCurrency != "" ) {
          
          if ( ACSCurrency.currentCurrency == mlvedaShopCurrency && $m('span.money').length > 0  && Array.from($m('span.money')).some(e => e.getAttribute('data-currency-'+mlvedaShopCurrency.toLowerCase()) == null)) {
            // console.log('mlvedaload called form mutation')
            if(typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") { mlvedaload(); }
            $m("<style type=\"text/css\"> span.money { display: inline;} </style>").appendTo("head");
            $m("<style type=\"text/css\"> .shopify-payment-button,form[action*='/cart/add'] [type='submit']{visibility:visible;}</style>").appendTo("head");
          } else if ( ACSCurrency.currentCurrency != mlvedaShopCurrency ) {
          
          if ( !convert_currency && mutation.target.nodeName.toLowerCase() == "span" && mutation.target.classList.length > 0  && mutation.target.className.indexOf('money') != -1 ) {
                  if ( !(mutation.target.getAttribute('data-currency')) ) {
                    convert_currency = true;
                  }
                }
                  
                if ( !convert_currency && mutation.target.querySelectorAll('span.money').length > 0) {
                  mutation.target.querySelectorAll('span.money').forEach( (currentElem) => {
                    if ( !(currentElem.getAttribute('data-currency')) ) {
                      convert_currency = true;
                    }
                  });
                 }
            }
        }

		if(mutation.type != "attributes" && first_call && !flag_for_updateprice){
		
                  for (var i = 0; i < mutation.addedNodes.length; i++) { 
                  //console.log(mutation.addedNodes[i])
                  if(mutation.addedNodes[i] instanceof Element && mutation.addedNodes[i].querySelector('span.money') != null && ((mutation.addedNodes[i].querySelector('a[href*="products"]:not(form[action*="/cart"] a):not(form[action*="/checkout"] a)') != null && neglectAnchors != '.' && Array.from(mutation.addedNodes[i].querySelectorAll('a[href*="products"]:not(form[action*="/cart"] a):not(form[action*="/checkout"] a)')).every(elem => { return $m(elem).parents(neglectAnchors).length == 0 })) || mutation.addedNodes[i].nodeName == 'A') ){
                    //             		console.log("-----------NEW------------------",mutation.addedNodes[i])
                      	$m("<style type=\"text/css\">span.money{ display: none; }</style>").appendTo("head");
                		//checkShopifyFormatMoney();
                      flag_for_updateprice = true;
            		}
              	}  
		
               
  		  }
            });
   if ( flag_for_updateprice && first_call ) {
  	checkShopifyFormatMoney()
    flag_for_updateprice = false;
//     console.log(mutations)
  } 
  				
            $m("select:not(.mlveda_country,.vichitra)").each(function(){
              var flag = 1;
              //console.log("select "+this);
              //console.log($m(this).children().length);
              $m(this).children().each(function(option){
                //console.log($m(this).parent().attr("class"));
                //if(($(this).parent().attr("class") !== 'mlveda_country') || ($(this).parent().attr("class") !== 'vichitra')){
                //console.log("option "+this);


                var str = $m(this).val().trim();
                //console.log("value "+str);
                var res = pattern.test(str);
                //console.log("result "+res);
                if(res){
                  flag=2;
                    return;
                }
                else{
                  //console.log("in else "+str);
                  $m(this).parent().addClass("vichitra");
                    flag = 0;
                    return false;
                }
              //}
              });
              //console.log("flag "+flag);
              if(flag==2){
                //console.log("it's time for magic");
                 $m(this).addClass("mlveda_country");
                //console.log($m(this));
                //$m(this).parent().css("display" , "none");

                //console.log($m(this).val());
              /*$m(this).val($m(this).val()).trigger("change");
               var event1 = new Event("change" , {bubbles : true});
                var mlveda_select = this;
                $m(this).val($m(this).val())[0].dispatchEvent(event1);		*/	
                
           var mlveda_interval = setInterval(()=> {
           //console.log("setInterval");
           //if($ && $._data($("select.mlveda_country")[0]).events && $._data($("select.mlveda_country")[0]).events.change["0"]){
if(
  ("undefined" != typeof lastSelectListenerInfo && lastSelectListenerInfo.length > 0 && lastSelectListenerInfo[0].a == "change") || ($m(this)[0].onchange != null) || ("undefined" != typeof lastFormListenerInfo && lastFormListenerInfo.length > 0 && lastFormListenerInfo[0].a == "change")
 )
 
{
             clearInterval(mlveda_interval);
              // var event1 = new Event("change", {
              //   bubbles: true
              // });
             mlveda_condition_flag_select = true;
             lastSelectListenerInfo = [];
              lastFormListenerInfo = [];
              //console.log("in set timeout");
              $m("select.mlveda_country").each(function(){
                //console.log("$m(this).val() : ",$m(this).val());
                   if(mcp_country && mcp_country !== null && $m(this).find('[value='+ mcp_country +']').length > 0){
                      $m(this).attr("mlveda_country_found","true");
                       //console.log("country");
                      $m(this).val(mcp_country)[0].dispatchEvent(new Event('change', { bubbles: true }))
                    }
                    else if(mcp_continent && mcp_continent !== null && $m(this).find('[value='+ mcp_continent +']').length > 0){
                      $m(this).attr("mlveda_continent_found","true");
                     // console.log("continent");
                      $m(this).val(mcp_continent)[0].dispatchEvent(new Event('change', { bubbles: true }))
                    }
                    else if(mcp_country !== null && mcp_continent !== null && $m(this).find('[value="intl"]').length > 0){
                      $m(this).val("intl")[0].dispatchEvent(new Event('change', { bubbles: true }))
                    }
              });
         } 
        }, 100);
                    //$m(this).addClass("mlveda_country");

              }
            });
          
            element_of_structure != '' && $m(element_of_structure+":not(.mlveda_country,.vichitra)").each(function(){
              var flag = 1;
              //console.log("select "+this);
              //console.log($m(this).children().length);
              $m(this).find("input").each(function(option){
   
                //console.log($m(this).parent().attr("class"));
                //if(($(this).parent().attr("class") !== 'mlveda_country') || ($(this).parent().attr("class") !== 'vichitra')){
                //console.log("option "+this);
     var str = $m(this).val().trim();

    if(str !== ""){
               
      //console.log("value "+str);
      var res = pattern.test(str);
      //console.log("result "+res);
      if(res){
        flag=2;
        return;
      }
      else{
        //console.log("in else "+str);
        $m(this).parents(element_of_structure).addClass("vichitra");
        flag = 0;
        return false;
      }
    }
              //}
              });
              //console.log("flag "+flag);
              if(flag==2){
                //console.log("it's time for magic");
                //console.log($m(this).parent());
                //$m(this).parent().css("display" , "none");
                $m(this).addClass("mlveda_country");
              //$m(this).val("si");
                 //$m('input:radio[name=mlveda_country][value=si]').click();
                //$m('label[for=ProductSelect-option-mlveda_country-intl]').trigger("click");
                
              /*  var event = new Event("click" , {bubble : true});
                var mlveda_select = this;
                mlveda_select.dispatchEvent(event);		*/
                
                var mlveda_interval = setInterval(function() {
           //console.log("setInterval 1");
           //if($ && $._data($("form[action*='/cart/add'] fieldset input")[0]).events && $._data($("form[action*='/cart/add'] fieldset input")[0]).events.change[0]){
if(
  (("undefined" != typeof lastInputListenerInfo && lastInputListenerInfo.length > 0 && lastInputListenerInfo[0].a == "change") || ("undefined" != typeof lastFormListenerInfo && lastFormListenerInfo.length > 0 && lastFormListenerInfo[0].a == "change"))
  
  ){
             clearInterval(mlveda_interval);
              var event1 = new Event("change", {
                bubbles: true
              });
             mlveda_condition_flag_input = true;
             lastInputListenerInfo = [];
 lastFormListenerInfo = [];
             //console.log("in set timeout 1");

             $m(element_of_structure+".mlveda_country").each(function(){
               if(mcp_country && mcp_country !== null && $m(this).find("input:radio[value="+mcp_country+"]").length > 0){
                  $m(this).attr("mlveda_country_found","true");
                  //console.log("vf : ",$m(this).find("input:radio[value="+country+"]"));	
                  $m(this).find("input:radio[value="+mcp_country+"]").click();
                  $m(this).find("input:radio[value="+mcp_country+"]").val(mcp_country).trigger("click");
                  $m(element_of_structure+".mlveda_country").val(mcp_country)[0].dispatchEvent(new Event("change",{bubbles : true}));
                }
                else if(mcp_continent && mcp_continent !== null && $m(this).find("input:radio[value="+mcp_continent+"]").length > 0){
                  $m(this).attr("mlveda_continent_found","true");
                  //console.log($m(this).find("input:radio[value="+continent+"]"));	
                  $m(this).find("input:radio[value="+mcp_continent+"]").click();
                  $m(this).find("input:radio[value="+mcp_continent+"]").val(mcp_continent).trigger("click");
                  $m(element_of_structure+".mlveda_country").val(mcp_continent)[0].dispatchEvent(new Event("change",{bubbles : true}));
                }
                else if(mcp_country !== null && mcp_continent !== null && $m(this).find("input:radio[value=intl]").length > 0){
                   //console.log($m(this).find("input:radio[value=intl]"));
                  $m(this).find("input:radio[value=intl]").click()
      $m(this).find("input:radio[value='intl']").val("intl").trigger("click");
                  $m(element_of_structure+".mlveda_country").val("intl")[0].dispatchEvent(new Event("change",{bubbles : true}));
                }
             });
   
           } 
        }, 100);
                
             
                    
              }
            });
          //ul-li flag=2
  
 if ( convert_currency ) {
    console.log("mlvedaload call !!!");
  	if(typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") { mlvedaload(); }
    convert_currency = false;
  }
        });
	
	
		
 //});

$m(document).ready(function() {

  mlveda_country_hide()
//  detect_structure()

  mlveda_observer.observe(document.body, { childList: true , subtree : true, attributes : true});

  checkShopifyFormatMoney()

  remove_mlveda();
  var mlveda_style = document.createElement('style')
  mlveda_style.type = 'text/css'
  mlveda_style.innerText = 'form[action*="/cart"] {visibility: visible}'
  document.head.appendChild(mlveda_style)  

})


window.addEventListener("load", function() {
 // detect_structure()
    setTimeout(function() {
		  // isSaleClass && $m("<style type='text/css'>"+ saleClass +"{ visibility : visible; }</style>").appendTo("head");
    	// isSaveAmount && $m("<style type='text/css'>"+ saveAmountClass +"{ visibility : visible; }</style>").appendTo("head");
 		  // isSalePercentage && $m("<style type='text/css'>"+ salePercentageClass +"{ visibility : visible; }</style>").appendTo("head");     
      //  for ( let i = 0; i < saleClasses.split(',').length; i++ ) {
      //   $m("<style type='text/css'>"+ saleClasses.split(',')[i]+"{ visibility : visible; }</style>").appendTo("head");
      // }
      $m("<style type='text/css'>"+ saleClasses+"{ visibility : visible; }</style>").appendTo("head");
      $m("<style type=\"text/css\">span.money{ display: inline; }</style>").appendTo("head");
    	$m("<style type=\"text/css\">  span.money {visibility:visible;}</style>").appendTo("head");
      $m("<style type=\"text/css\">  .shopify-payment-button,form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");
    },3000);

});

var mlvedaCallUrl_location = "//www.mlveda.com/ShopifyApps/ShopifyMultiPricing/getLocation?shop="+ MCP_shop_permanent_domain +"&rnd=" + Math.floor((Math.random() * 10000000000) + 1);

var mcp_country = null;
var mcp_continent = null;
var countryFound = false;  
var continentFound = false
      var abcd = $m.ajax({
        url: mlvedaCallUrl_location,
        type: "GET",
        dataType: "json",
        async: true,
        timeout: 10000,
        success: function(response) {
        if (response === "") {
       		$m("<style type=\"text/css\">  span.money {visibility:visible;}</style>").appendTo("head");
 			$m("<style type=\"text/css\">  .shopify-payment-button,form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");        
      	}
        else {
          var new_flag = false;
              mcp_country = response.country;
        	  mcp_continent = response.continent;
        //console.log("success");

      //  detect_structure()
       
          if (($m("select.mlveda_country").val() !== mcp_country && mcp_country!=null) || ($m("select.mlveda_country").val() !== mcp_continent && mcp_continent!=null) || $m("select.mlveda_country").val() !== "intl")
    			{
                  //console.log("first if of ajax");
      			//console.log($m("select.mlveda_country").parent().find("select").val());
      			//console.log("country is " + country);
                  
                  if(mlveda_condition_flag_select){
                  $m("select.mlveda_country").each(function(){
                        if ($m(this).find('option[value='+ mcp_country  + ']').length !=0 || $m(this).find('option[value='+ mcp_continent  + ']').length !=0 || $m(this).find('option[value="intl"]').length !=0)
                        {
                          //console.log("in second if of ajax");
                          
                              if($m(this).find('option[value='+ mcp_country  + ']').length != 0) {
                                //console.log($m("select.mlveda_country"));
                                //console.log("country found from ajax");
                                $m(this).attr("mlveda_country_found","true");
                                //check_for_options($m("select.mlveda_country") , country);
                                $m(this).val(mcp_country)[0].dispatchEvent(new Event("change", {bubbles: true}));
                              }
                              else if($m(this).find('option[value='+ mcp_continent  + ']').length !=0) {
                                //console.log("continent found from Ajax");
                                //check_for_options($m("select.mlveda_country") , continent);
                                $m(this).attr("mlveda_continent_found","true");
                                $m(this).val(mcp_continent)[0].dispatchEvent(new Event("change", {bubbles: true}));
                              }
                              else {
                                //check_for_options($m("select.mlveda_country") , "intl");
                                $m(this).val("intl")[0].dispatchEvent(new Event("change", {bubbles: true}));
                              }
                              //console.log("1111");

                              //$m("<style type=\"text/css\">  div.mlvedaform span.money {visibility:visible;}</style>").appendTo("head");
			      $m("<style type=\"text/css\"> span.money {visibility:visible;}</style>").appendTo("head");
                              //$m("<style type=\"text/css\"> div.mlvedaform h2.price {display:block;}</style>").appendTo("head");
				
          			//$m("<style type=\"text/css\">  form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");
          				
                         }
                         else{
                          $m("<style type=\"text/css\">  span.money {visibility:visible;}</style>").appendTo("head");
			    
          			//$m("<style type=\"text/css\">  form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");
          					
                         }

                 });
                  }
                  
		if(!one_more_flag){
//                  if($m("select.mlveda_country").find("option").length <=1)
//                  {
                   //console.log("1112");
                        //$m("<style type=\"text/css\">  div.mlvedaform span.money {visibility:visible;}</style>").appendTo("head");
			$m("<style type=\"text/css\">   span.money {visibility:visible;}</style>").appendTo("head");
                   //$m("<style type=\"text/css\"> div.mlvedaform h2.price {visibility:visible;}</style>").appendTo("head");
		   
          			//$m("<style type=\"text/css\">  form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");
          	
//                  }
		}
                  
    			}	
   
          if (($m(element_of_structure+".mlveda_country").val() !== mcp_country && mcp_country!=null) || ($m(element_of_structure+".mlveda_country").val() !== mcp_continent && mcp_continent!=null) || $m(element_of_structure+".mlveda_country").val() !== "intl")
    			{
      			//console.log($m(element_of_structure+".mlveda_country").parent().find("select").val());
      			//console.log("country is " + country);
                  if(mlveda_condition_flag_input){
				$m(element_of_structure+".mlveda_country").each(function(){	
					if ($m(this).find('input[value='+ mcp_country  + ']').length !=0 || $m(this).find('input[value='+ mcp_continent  + ']').length !=0 || $m(this).find('input[value="intl"]').length !=0)
					{
						
						  if($m(this).find('input[value='+ mcp_country  + ']').length !=0) {
							//console.log("country found from ajax");
							//console.log($m(this).val());
							//var mlveda_interval = setInterval(() => {
							  new_flag = true;
							//console.log("setInterval");
							  //if($ && $._data($("form[action*='/cart/add'] fieldset input")[0]).events && $._data($("form[action*='/cart/add'] fieldset input")[0]).events.change[0]){
							   //clearInterval(mlveda_interval);
							   //console.log("in set timeout");
							   $m(this).attr("mlveda_country_found","true");
							  $m(element_of_structure+".mlveda_country").find("input:radio[value="+mcp_country+"]").click();
                              $m(element_of_structure+".mlveda_country").find("input:radio[value="+mcp_country+"]").val(mcp_country).trigger("click");
							  $m(element_of_structure+".mlveda_country").val(mcp_country)[0].dispatchEvent(new Event("change",{bubbles : true}));

							  //} 
							//}, 100);
							
						  }
						  else if($m(this).find('input[value='+ mcp_continent  + ']').length !=0) {
							//var mlveda_interval = setInterval(() => {
							  new_flag = true;
							//console.log("setInterval");
							  //if($ && $._data($("form[action*='/cart/add'] fieldset input")[0]).events && $._data($("form[action*='/cart/add'] fieldset input")[0]).events.change[0]){
							   //clearInterval(mlveda_interval);
							   //console.log("in set timeout");
							   $m(this).attr("mlveda_continent_found","true");
                              $m(element_of_structure+".mlveda_country").find("input:radio[value="+mcp_continent+"]").click();
			                  $m(element_of_structure+".mlveda_country").find("input:radio[value="+mcp_continent+"]").val(mcp_continent).trigger("click");
							  $m(element_of_structure+".mlveda_country").val(mcp_continent)[0].dispatchEvent(new Event("change",{bubbles : true}));

							  //} 
							//}, 100);
							
						  }
						  else {
							//console.log("In the else");
							//var mlveda_interval = setInterval(() => {
							  new_flag = true;
							//console.log("setInterval");
							  //if($ && $._data($("form[action*='/cart/add'] fieldset input")[0]).events && $._data($("form[action*='/cart/add'] fieldset input")[0]).events.change[0]){
							   //clearInterval(mlveda_interval);
							   //console.log("in set timeout");
							  $m(element_of_structure+".mlveda_country").find("input:radio[value='intl']").click();
			                  $m(element_of_structure+".mlveda_country").find("input:radio[value='intl']").val("intl").trigger("click");
							  $m(element_of_structure+".mlveda_country").val("intl")[0].dispatchEvent(new Event("change",{bubbles : true}));

							  //} 
							//}, 100);
							
						  }
						  //console.log("here--1");
						  if(new_flag){
						  $m("<style type=\"text/css\">  span.money {visibility:visible;}</style>").appendTo("head");
//  						  $m("<style type=\"text/css\">  .shopify-payment-button,form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");                                    
						  }
					}
					  else{
						$m("<style type=\"text/css\">   span.money {visibility:visible;}</style>").appendTo("head");
//  						$m("<style type=\"text/css\">  .shopify-payment-button,form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");                                 
					  }
				});
                }
                 if(!one_more_flag){ 
//                    if($m(element_of_structure+".mlveda_country").find("input").length <=1)
//                    {
                     //console.log("1112");
                     $m("<style type=\"text/css\">   span.money {visibility:visible;}</style>").appendTo("head");
//                      $m("<style type=\"text/css\">  .shopify-payment-button,form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");
//                    }
                 }
                         
    			}	
        
//ul-li ajaxcall
        
          		
            } 
        },
        error: function(xhr, textStatus, errorThrown) {
            $m("<style type=\"text/css\">   span.money {visibility:visible;}</style>").appendTo("head");
 			$m("<style type=\"text/css\">  .shopify-payment-button,form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");                 
        //console.log("timeout");
      }
});

  $m("body").delegate("select.mlveda_country", "change", function(event) {
    //console.log("change trigerred");
    //  console.log($m("select.mlveda_country:last"));
      //console.log($m('select.mlveda_country'));
    //  console.log("id = "+mlveda_select_id);
      //console.log("value : "+$m('select.mlveda_country').val());
      
      if(mcp_country !== null && mcp_continent !== null){
      
        if ($m('select.mlveda_country').val() && $m('select.mlveda_country').val() !== mcp_country && $m('select.mlveda_country').find('option[value='+ mcp_country  + ']').length !=0)
        {
          //console.log($m("select.mlveda_country").parent().find("select").val());
          //console.log("country is " + country);
    //     if ($m('select.mlveda_country').find('option[value='+ mcp_country  + ']').length !=0)
    //     {
          //console.log("country found")  ;
          //countryFound = true;
          $m('select.mlveda_country').attr("mlveda_country_found","true");
            $m('select.mlveda_country').val(mcp_country)[0].dispatchEvent(new Event("change", {bubbles: true}));
            /*$m('span.money span.money').each(function() {
                $m('select.mlveda_country').parents('span.money').removeClass('money');
            });*/
        $m('.money').parents('.money').removeClass('money');
    //     }
          //console.log("1114");
        //$m("<style type=\"text/css\">  div.mlvedaform span.money {visibility:visible;}</style>").appendTo("head"); 
        $m("<style type=\"text/css\"> span.money {visibility:visible;}</style>").appendTo("head");
          //$m("<style type=\"text/css\"> div.mlvedaform h2.price {visibility:visible;}</style>").appendTo("head");
        
                  //$m("<style type=\"text/css\">  form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");
         
        }
     
      else if ($m('select.mlveda_country').val() && $m('select.mlveda_country').val() !== mcp_continent && $m('select.mlveda_country').attr("mlveda_country_found") === undefined && $m('select.mlveda_country').find('option[value='+ mcp_continent  + ']').length !=0)
        {
          
          //console.log($m("select.mlveda_country").parent().find("select").val());
          //console.log("continent is " + continent);
    //     if ($m('select.mlveda_country').find('option[value='+ mcp_continent  + ']').length !=0)
    //     {
                //console.log("continent found") ; 
    
          //continentFound = true
          $m('select.mlveda_country').attr("mlveda_continent_found","true");
            $m('select.mlveda_country').val(mcp_continent)[0].dispatchEvent(new Event("change", {bubbles: true}));
            /*$m('span.money span.money').each(function() {
                $m('select.mlveda_country').parents('span.money').removeClass('money');
            });*/
        $m('.money').parents('.money').removeClass('money');
    //     }
          //console.log("1115");
        //$m("<style type=\"text/css\">  div.mlvedaform span.money {visibility:visible;}</style>").appendTo("head");
        $m("<style type=\"text/css\"> span.money {visibility:visible;}</style>").appendTo("head");
          //$m("<style type=\"text/css\"> div.mlvedaform h2.price {visibility:visible;}</style>").appendTo("head");
    
              //$m("<style type=\"text/css\">  form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");
         
        }
      else
      {
        //console.log($m("select.mlveda_country:last").val());
      //console.log($m("select.mlveda_country:last").find('option[value="intl"]').length);
        //console.log("country : "+countryFound);
        //console.log("country : "+continentFound);
        //console.log("country : "+intlFound);
        if ($m('select.mlveda_country').find('option[value="intl"]').length !=0 && $m('select.mlveda_country').attr("mlveda_country_found") === undefined && $m('select.mlveda_country').attr("mlveda_continent_found") === undefined && $m('select.mlveda_country').val() && $m('select.mlveda_country').val() !== 'intl')
        {
                //console.log("intl found");
            intlFound = true;
            $m('select.mlveda_country').val("intl")[0].dispatchEvent(new Event("change", {bubbles: true}));
            /*$m('span.money span.money').each(function() {
                $m('select.mlveda_country').parents('span.money').removeClass('money');
            });*/
        $m('.money').parents('.money').removeClass('money');
        }
        //console.log("1116");
        if(mcp_country !== null && mcp_continent !== null){
          //console.log("seen");
            //$m("<style type=\"text/css\">  div.mlvedaform span.money {visibility:visible;}</style>").appendTo("head");
          $m("<style type=\"text/css\">  span.money {visibility:visible;}</style>").appendTo("head");
          //$m("<style type=\"text/css\"> div.mlvedaform h2.price {display:block !important;}</style>").appendTo("head");
    
              //$m("<style type=\"text/css\">  form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");
              
        }
      }
      }
    });	

  $m("body").delegate(element_of_structure+".mlveda_country", "change", function(event) {
    //console.log("change trigerred");
        //console.log($m("fieldset#"+mlveda_select_id+".mlveda_country").val());
    //  console.log($m("fieldset#"+mlveda_select_id+".mlveda_country input:radio[name='mlveda_country']:checked"));
    
      //console.log("this",$(this));
      //console.log("this value",$(this).val());
        if(mcp_country !== null && mcp_continent !== null){
          //if ($m(element_of_structure+".mlveda_country > input:radio[name='mlveda_country']:checked").val() && $m(element_of_structure+".mlveda_country > input:radio[name='mlveda_country']:checked").val() !== country && country!=null && $m(element_of_structure+".mlveda_country").find('input:radio[value='+country+']').length !=0)
                  if ($m(element_of_structure+".mlveda_country input:radio:checked").val() && $m(element_of_structure+".mlveda_country input:radio:checked").val() !== mcp_country && $m(element_of_structure+".mlveda_country").find('input:radio[value='+mcp_country+']').length !=0)			
    
            {
            //console.log($m(element_of_structure+".mlveda_country").parent().find("select").val());
            //console.log("country is " + country);
           // console.log("country is : "+$m(element_of_structure+".mlveda_country").find('input:radio[value='+ country  + ']').length);
    // 			  if ($m(element_of_structure+".mlveda_country").find('input:radio[value='+ country  + ']').length !=0)
    // 			{
            //console.log("country found")  ;
            countryFound = true;
            $m(element_of_structure+'.mlveda_country').attr("mlveda_country_found","true");
          
            $m(element_of_structure+".mlveda_country").find("input:radio[value="+mcp_country+"]").click();
                    $m(element_of_structure+".mlveda_country").find("input:radio[value="+mcp_country+"]").val(mcp_country).trigger("click");
            $m(element_of_structure+".mlveda_country").val(mcp_country)[0].dispatchEvent(new Event("change",{bubbles : true}));
            
            /*$m('span.money span.money').each(function() {
              $m(element_of_structure+'.mlveda_country').parents('span.money').removeClass('money');
            });*/
            $m('.money').parents('.money').removeClass('money');
    // 			}
          $m("<style type=\"text/css\">   span.money {visibility:visible;}</style>").appendTo("head");
    //  			$m("<style type=\"text/css\">  .shopify-payment-button,form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");                       
          }
         
          else if ($m(element_of_structure+".mlveda_country input:radio:checked").val() && $m(element_of_structure+".mlveda_country input:radio:checked").val() !== mcp_continent && $m(element_of_structure+'.mlveda_country').attr("mlveda_country_found") === undefined && $m(element_of_structure+".mlveda_country").find('input:radio[value='+ mcp_continent + ']').length !=0)
          {
            
            //console.log($m(element_of_structure+".mlveda_country").parent().find("select").val());
            //console.log("continent is " + continent);
    // 			if ($m(element_of_structure+".mlveda_country").find('input[value='+ continent  + ']').length !=0)
    // 			{
              //console.log("continent found") ; 
    
            continentFound = true;
            $m(element_of_structure+'.mlveda_country').attr("mlveda_continent_found","true");
            //$m(element_of_structure+".mlveda_country > input:radio[name='mlveda_country'][value="+country+"]").val(country).trigger("click");
            $m(element_of_structure+".mlveda_country").find("input:radio[value="+mcp_continent+"]").click();
                    $m(element_of_structure+".mlveda_country").find("input:radio[value="+mcp_continent+"]").val(mcp_continent).trigger("click");
            $m(element_of_structure+".mlveda_country").val(mcp_continent)[0].dispatchEvent(new Event("change",{bubbles : true}));
    
            /*$m('span.money span.money').each(function() {
              $m(element_of_structure+'.mlveda_country').parents('span.money').removeClass('money');
            });*/
            $m('.money').parents('.money').removeClass('money');
    // 			}
          $m("<style type=\"text/css\">   span.money {visibility:visible;}</style>").appendTo("head");
    //  			$m("<style type=\"text/css\">  .shopify-payment-button,form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head")                       
          }
          else
          {
          if ( $m(element_of_structure+'.mlveda_country').attr("mlveda_country_found") === undefined && $m(element_of_structure+'.mlveda_country').attr("mlveda_continent_found") === undefined && $m(element_of_structure+".mlveda_country input:radio:checked").val() && $m(element_of_structure+".mlveda_country input:radio:checked").val() !== 'intl' && $m(element_of_structure+".mlveda_country").find('input[value="intl"]').length !=0)
          {
              //console.log("intl found");
                    $m(element_of_structure+".mlveda_country").find("input:radio[value='intl']").click();
                    $m(element_of_structure+".mlveda_country").find("input:radio[value='intl']").val('intl').trigger("click");
            $m(element_of_structure+".mlveda_country").val('intl')[0].dispatchEvent(new Event("change",{bubbles : true}));
            /*$m('span.money span.money').each(function() {
              $m(element_of_structure+'.mlveda_country').parents('span.money').removeClass('money');
            });*/
            $m('.money').parents('.money').removeClass('money');
          }
            $m("<style type=\"text/css\">   span.money {visibility:visible;}</style>").appendTo("head");
    //  				$m("<style type=\"text/css\">  .shopify-payment-button,form[action*='/cart/add'] [type='submit'], form[action*='/cart/add'] [type='button'], form[action*='/cart/add'] [name='add'], form[action*='/cart'] [name='checkout']{visibility:visible;}</style>").appendTo("head");                     
          
          }
      }
    });	

//ul-li-delegate

// functions can be defined in theme-independent code
function checkProductRange(currentElement, parentElement){
  currentProductName = $m(currentElement).attr('href').split('/')[$m(currentElement).attr('href').split('/').length-1];
 return $m(parentElement).find('a[href*="/products/"]').toArray().every(function(element){
	var singleProductName = $m(element).attr('href').split('/')[$m(element).attr('href').split('/').length -1];
    return singleProductName.split('?')[0] == currentProductName.split('?')[0];
  })
}

function findSaleDetails(className){
 var TotalSaleClass = className.split(",").length;
    var tempSaleTag = $m(this).find(className);
    if(tempSaleTag.length == 0 && $m(this).parent().find(className).length <= TotalSaleClass){
      tempSaleTag = $m(this).parent().find(className);
      if(tempSaleTag.length == 0 && checkProductRange($m(this), $m(this).parent().parent()) && $m(this).parent().parent().find(className).length <= TotalSaleClass){
        tempSaleTag = $m(this).parent().parent().find(className);
        if(tempSaleTag.length == 0 && checkProductRange($m(this), $m(this).parent().parent().parent().parent()) && $m(this).parent().parent().parent().parent().find(className).length <= TotalSaleClass){
          tempSaleTag = $m(this).parent().parent().parent().parent().find(className);
        }
      }	
    }
  if ( tempSaleTag && tempSaleTag.text().toLowerCase().indexOf('sold') == -1 ) {
    return tempSaleTag;
  } else {
    return undefined;
  }
}

var Fromregex = /from|von|Ã  partir de|desde|van|de|da|\+/i;
var Textremoved=textWithPrice.replaceAll(",","|"); 
var tRegex = new RegExp(Textremoved, 'gi');
//var tRegex=/On sale|Now/gi;
function removeFrom(){ 
  
  $m(".money").parent().find(".icon-fallback-text").remove();
  
 var spanmoneyelement = document.querySelectorAll("span.money");
  for(var i=0; i<spanmoneyelement.length; i++){
    if ( spanmoneyelement[i].closest('form[action*="/cart"]') != null && spanmoneyelement[i].closest('form[action*="/add"]') == null ) {
    	continue;
    }
	var fromelement = spanmoneyelement[i].parentNode;
    if(fromelement != null && !(Fromregex.test(fromelement.textContent))){
       fromelement = fromelement.parentNode;
     }	
    if(fromelement != null){
    var frommatch = fromelement.textContent.match(Fromregex);
    if(frommatch != null && $m(fromelement).find("select[name='id']").length <= 0){

   var allElements = fromelement.querySelectorAll("*");
    for(var j=0; j<allElements.length; j++){
if(allElements[j] && allElements[j].previousSibling && Fromregex.test(allElements[j].previousSibling.textContent.trim()) && allElements[j].previousSibling.textContent.trim().match(Fromregex) && (allElements[j].previousSibling.textContent.trim().match(Fromregex)[0].length == allElements[j].previousSibling.textContent.trim().length || (textWithPrice.length > 0 && allElements[j].previousSibling.textContent.trim().match(tRegex) != null))){
        	//console.log("from textContent");
			allElements[j].previousSibling.textContent = allElements[j].previousSibling.textContent.replace(Fromregex,"");
			//return false;
      	  }
      
      if(allElements[j] && allElements[j].nextSibling && Fromregex.test(allElements[j].nextSibling.textContent.trim()) && allElements[j].nextSibling.textContent.trim().match(Fromregex) && (allElements[j].nextSibling.textContent.trim().match(Fromregex)[0].length == allElements[j].nextSibling.textContent.trim().length || (textWithPrice.length > 0 && allElements[j].nextSibling.textContent.trim().match(tRegex) != null))){
        	//console.log("from textContent");
			allElements[j].nextSibling.textContent = allElements[j].nextSibling.textContent.replace(Fromregex,"");
			//return false;
      	  }
      
if(allElements[j].children.length == 0 && allElements[j].textContent != null && Fromregex.test(allElements[j].textContent) && allElements[j].textContent.trim().match(Fromregex) && (allElements[j].textContent.trim().match(Fromregex)[0].length === allElements[j].textContent.trim().length || (textWithPrice.length > 0 && allElements[j].innerText != null && allElements[j].textContent.trim().match(tRegex) != null))){
			//console.log("from innnerHTML");
		allElements[j].innerHTML = allElements[j].textContent.replace(Fromregex,"");
          }
		}
	  }	
    }
  }
}

function removeOtherText(referenceElement, Texttoberemoved){
  Texttoberemoved=Texttoberemoved.toLowerCase().replaceAll(",","|");
//add i in regex to ignore case
var textRegex = new RegExp(Texttoberemoved,'gi');
 for(var i=0;i<referenceElement.length;i++){
   var tempElemet = referenceElement[i].parentNode;
   if(tempElemet.innerHTML.match(textRegex) == null){
      tempElemet = tempElemet.parentNode;
    } 
  for(var a=0; a<tempElemet.children.length; a++){
    if(tempElemet.children[a].previousSibling != null && tempElemet.children[a].previousSibling.textContent.trim().length > 0 && textRegex.test(tempElemet.children[a].previousSibling.textContent.trim())){
        tempElemet.children[a].previousSibling.textContent = tempElemet.children[a].previousSibling.textContent.replace(textRegex,"");
        //console.log("from text Content");
    }
    if(tempElemet.children[a].innerHTML != null && textRegex.test(tempElemet.children[a].innerHTML)){
        tempElemet.children[a].innerHTML = tempElemet.children[a].innerHTML.replace(textRegex,"");
        //console.log("from innerHTML");
    }
   }
  }
}
 
  
                
var mlvedaCallUrl_prices = "//www.mlveda.com/ShopifyApps/ShopifyMultiPricing/getPrices?shop="+MCP_shop_permanent_domain;
//$m(".icon-fallback-text").remove();

function checkShopifyFormatMoney() {

mlvedaFlagCalled = false

// if (isSalePercentage){
// 	var percentElement = document.querySelectorAll(salePercentageClass);
// 	let percentElementArray = Array.from(percentElement)
// 	percentElementArray.forEach(function (item, index) {
// 	  var hasmoneyclass= item.classList.contains("money");
// 	  if (hasmoneyclass){
// 	          item.classList.remove("money")
// 	  }
// 	});
// }

var data = [];
var mlvedaData = {};
  
 $m.fn.removeAttributes = function() {
  // return this.each(function() {
  //   var attributes = $m.map(this.attributes, function(item) {
  //     return item.name;
  //   });
  //   var span = $m(this);
  //   $m.each(attributes, function(i, item) {
  //   span.removeAttr(item);
  //   });
  // });
   
  for ( let i = 0; i < $m(this).length > 0; i++ ) {
    while ( $m(this)[i].attributes.length > 0 ) {
   	  $m(this)[i].removeAttribute($m(this)[i].attributes[0].name);
    }
  }

}

 removeFrom();

// var dataSet = [];
 
$m('a[href*="/products/"]').each(function() {   
    if($m(this).attr("href").indexOf(".jpeg") == -1 && $m(this).attr("href").indexOf(".jpg") == -1  && $m(this).attr("href").indexOf(".png") == -1 ){

      var $mhandleArray = $m(this).attr('href').split("/");
      var $mhandle = $mhandleArray[$mhandleArray.length - 1].split("\?")[0];

      if(data.every( (e) => { return e.url !== $mhandle } )){
          data.push({"url": decodeURI($mhandle)});
      }
    }
});


mlvedaData = {"data": data};
  

if(data == ""){ 
  first_call = true
	//$m("<style type=\"text/css\">span.money{ display: inline;}</style>").appendTo("head");
	// isSaleClass && $m("<style type='text/css'>"+ saleClass +"{ visibility : visible; }</style>").appendTo("head");
	// isSaveAmount && $m("<style type='text/css'>"+ saveAmountClass +"{ visibility : visible; }</style>").appendTo("head");
	// isSalePercentage && $m("<style type='text/css'>"+ salePercentageClass +"{ visibility : visible; }</style>").appendTo("head");
  // for ( let i = 0; i < saleClasses.split(',').length; i++ ) {
  //   $m("<style type='text/css'>"+ saleClasses.split(',')[i]+"{ visibility : visible; }</style>").appendTo("head");
  //  }
  $m("<style type='text/css'>"+ saleClasses+"{ visibility : visible; }</style>").appendTo("head");
  mlvedaFlagCalled = true;
 	if(typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") { mlvedaload(); }  
 	return false; 
}

    var abcd = $m.ajax({
        url: mlvedaCallUrl_prices,
        type: "POST",
        dataType: "json",
        timeout: 10000,
        data: {data: JSON.stringify(mlvedaData)},
        success: function(response) {
            if (response === "") {
              first_call = true
              removeFrom();
	//  isSaleClass && $m("<style type='text/css'>"+ saleClass +"{ visibility : visible; }</style>").appendTo("head");
  //         isSaveAmount &&$m("<style type='text/css'>"+ saveAmountClass +"{ visibility : visible; }</style>").appendTo("head");
  //        isSalePercentage &&$m("<style type='text/css'>"+ salePercentageClass +"{ visibility : visible; }</style>").appendTo("head");
  // for ( let i = 0; i < saleClasses.split(',').length; i++ ) {
  //   $m("<style type='text/css'>"+ saleClasses.split(',')[i]+"{ visibility : visible; }</style>").appendTo("head");
  //  }   
  $m("<style type='text/css'>"+ saleClasses+"{ visibility : visible; }</style>").appendTo("head");
   $m("<style type=\"text/css\">span.money { display: inline; }</style>").appendTo("head");
                mlvedaFlagCalled = true;
                if(typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") {
                  mlvedaload();
                }
            }
            else {
              first_call = true
              removeFrom();
                   $m('.money').parents('.money').removeClass('money');	
                $m.each(response.data, function(index, element) {
                  if( element.price ){
                    $m('a').each(function() {
                      if($m(this).attr("href") && $m(this).parents(neglectAnchors).length == 0 && $m(this).attr("href").indexOf("view=quick") == -1 && $m(this).attr("href").replace(/\?.*/,"").split('/')[$m(this).attr("href").replace(/\?.*/,"").split('/').length - 1] === encodeURI(element.url)){
                        if (element.variantId)
                        {
                            $m(this).attr("href", $m(this).attr('href').split('?variant=')[0] + "?variant=" + element.variantId);
                        }
                        
                        if( $m(this).parent().parent().find('form[action*="/cart/add"] input[name="id"]').length > 0 && element.variantId ) {
    						$m(this).parent().parent().find('form[action*="/cart/add"] input[name="id"]').val(element.variantId);
  						}

                        
                      // if($m(this).find(".money").length <= 0 && $m(this).parent().find(".price__regular").length > 0 &&$m(this).parent().find(".price__sale").length > 0 && $m(this).parent().find(".price__sale dd").length > 1){
                      //       if($m(this).parent().find(".price__regular:visible").length > 0){
                      //         $mmlvedamoney = $m(this).find(".price__regular:visible .money:not("+ moneyNeglect +")");
                      //         if(!$mmlvedamoney.html() && $m(this).parent().find(".price__regular:visible .money:not("+ moneyNeglect +")").length <=2){
                      //           $mmlvedamoney = $m(this).parent().find(".price__regular:visible .money:not("+ moneyNeglect +")");
                      //           if (!$mmlvedamoney.html() && $m(this).parent().parent().find(".price__regular:visible .money:not("+ moneyNeglect +")") <=2)
                      //           {
                      //             $mmlvedamoney = $m(this).parent().parent().find(".price__regular:visible .money:not("+ moneyNeglect +")");
                      //           }
                      //         }
                      //       }
                      //       else{
                      //         $mmlvedamoney = $m(this).find(".price__sale:visible .money:not("+ moneyNeglect +")");
                      //         if(!$mmlvedamoney.html() && $m(this).parent().find(".price__sale:visible .money:not("+ moneyNeglect +")").length <=2){
                      //           $mmlvedamoney = $m(this).parent().find(".price__sale:visible .money:not("+ moneyNeglect +")");
                      //           if (!$mmlvedamoney.html() && $m(this).parent().parent().find(".price__sale:visible .money:not("+ moneyNeglect +")").length <=2)
                      //           {
                      //             $mmlvedamoney = $m(this).parent().parent().find(".price__sale:visible .money:not("+ moneyNeglect +")");
                      //           }
                      //         }
                      //       }
                      //   }
                      //   else{
                            $mmlvedamoney = $m(this).find(".money:not("+ moneyNeglect +")");
                            if(!$mmlvedamoney.html() && $m(this).parent().find(".money:not("+ moneyNeglect +")").length <= 3){
                              $mmlvedamoney = $m(this).parent().find(".money:not("+ moneyNeglect +")");
                              if (!$mmlvedamoney.html() && $m(this).parent().parent().find(".money:not("+ moneyNeglect +")").length <= 3)
                              {
                                $mmlvedamoney = $m(this).parent().parent().find(".money:not("+ moneyNeglect +")");
                              }
                            }
                        // }

                        if ($mmlvedamoney.html() && $m(this).parent().parent().find("select[name='id']").closest('form:visible').length == 0 && $m(this).parents('form[action*="/cart"]').length == 0)
                        {
                          
                          if( $mmlvedamoney.parents(".price__sale").length > 0 && $mmlvedamoney.parents(".price__regular").length > 0 ){
                            if ( $mmlvedamoney.parents(".price__sale").find('.price-item--regular').length > 0 ) {
                              if ( $m(this).find('.money').length > 0 ) {
                                var $mfirstMlvedamoney = $m(this).find('.money:not(.price__sale .price-item--regular .money)')
                                var $msecondMlvedamoney = $m(this).find('.price__sale .price-item--regular .money')
                              } else if ( $m(this).parent().find('.money').length > 0 && checkProductRange($m(this), $m(this).parent()) ) {
                                var $mfirstMlvedamoney = $m(this).parent().find('.money:not(.price__sale .price-item--regular .money)')
                                var $msecondMlvedamoney = $m(this).parent().find('.price__sale .price-item--regular .money')
                              } else if ( $m(this).parent().parent().find('.money').length > 0 && checkProductRange($m(this), $m(this).parent().parent()) ) {
                                var $mfirstMlvedamoney = $m(this).parent().parent().find('.money:not(.price__sale .price-item--regular .money)')
                                var $msecondMlvedamoney = $m(this).parent().parent().find('.price__sale .price-item--regular .money')
                              }
                            } else if ( $mmlvedamoney.parents(".price__sale").find('.price-item--compare').length > 0 ) {
                              if ( $m(this).find('.money').length > 0 ) {
                                var $mfirstMlvedamoney = $m(this).find('.money:not(.price__sale .price-item--compare .money)')
                                var $msecondMlvedamoney = $m(this).find('.price__sale .price-item--compare .money')
                              } else if ( $m(this).parent().find('.money').length > 0 && checkProductRange($m(this), $m(this).parent()) ) {
                                var $mfirstMlvedamoney = $m(this).parent().find('.money:not(.price__sale .price-item--compare .money)')
                                var $msecondMlvedamoney = $m(this).parent().find('.price__sale .price-item--compare .money')
                              } else if ( $m(this).parent().parent().find('.money').length > 0 && checkProductRange($m(this), $m(this).parent().parent()) ) {
                                var $mfirstMlvedamoney = $m(this).parent().parent().find('.money:not(.price__sale .price-item--compare .money)')
                                var $msecondMlvedamoney = $m(this).parent().parent().find('.price__sale .price-item--compare .money')
                              }
                            }else{
                              var $mfirstMlvedamoney = $mmlvedamoney[0] != null ? $m($mmlvedamoney[0]) : null;
                              var $msecondMlvedamoney = $mmlvedamoney[1] != null ? $m($mmlvedamoney[1]) : null;
                            }
                          } else{
                            var $mfirstMlvedamoney = $mmlvedamoney[0] != null ? $m($mmlvedamoney[0]) : null;
                            var $msecondMlvedamoney = $mmlvedamoney[1] != null ? $m($mmlvedamoney[1]) : null;
                          }
                          
//                       	    $mmlvedamoney.each(function() {
//                             if($mfirstMlvedamoney == null) {
//                               $mfirstMlvedamoney = $m(this);
//                             }
//                             else if($msecondMlvedamoney == null ) {
//                               $msecondMlvedamoney = $m(this);//parseInt($m(this).html().replace(/[^0-9]/g, ""),10);
//                             }
//                             else {                              
//                               return false;//parseInt($m(this).html().replace(/[^0-9]/g, ""),10)                              
//                             }                           
                            
//                           });
                          
                        var $saleElement;
                          // if(isSaleClass){
                          //   $saleElement = findSaleDetails.call($m(this), saleClass);
                          // }
                          
                            $saleElement = findSaleDetails.call($m(this), saleClass);
                          

                          var $saveAmountElement;
                          // if(isSaveAmount){
                          //   $saveAmountElement  = findSaleDetails.call($m(this),saveAmountClass);
                          // }
                          $saveAmountElement  = findSaleDetails.call($m(this),saveAmountClass);

                          var $salePercentage;
                          // if(isSalePercentage){
                          //   $salePercentage = findSaleDetails.call($m(this), salePercentageClass);		
                          // }
                          $salePercentage = findSaleDetails.call($m(this), salePercentageClass);	
                          var element_price, element_compare_at_price

                          element_price = element.price.indexOf(".") == -1 ? element.price * 100 : element.price
                          if ( element.compare_at_price ) {
                            element_compare_at_price = element.compare_at_price.indexOf(".") == -1 ? element.compare_at_price * 100 : element.compare_at_price
                          }

                          if($msecondMlvedamoney == null || $msecondMlvedamoney.length == 0) {
                            $mfirstMlvedamoney.html(Mlveda.formatMoney(element_price, MCP_shop_money_format));
                          
                            $mfirstMlvedamoney.removeAttributes();
                            $mfirstMlvedamoney.addClass("money");
                            // $mfirstMlvedamoney.each(function(){
                            //   this.setAttribute("style", "color: " + priceColor + "!important");
                            // })
                          //  console.log( $m(this))
                          //  console.log( $m(this).css('color'))
                          if( priceColor ==""){ a= $m(this).css('color') }
                          pcolor=priceColor==""?a:priceColor
                           $mfirstMlvedamoney.each(function(){
                              this.setAttribute("style", "color: " + pcolor + "!important");
                            })
                        
                            if("undefined" != typeof element_compare_at_price){
                              $saveAmountElement.each((i, elem) => { $m(elem).find("span.money").replaceWith(Mlveda.formatMoney((element_compare_at_price- element_price).toFixed(2), MCP_shop_money_format_with_span_money)) })
                              $salePercentage.each((i, elem) => { elem.innerHTML.length > 0 && $m(elem).html($salePercentage.html().replace(/\d{1,2}%/g,  "" +(((element_compare_at_price - element_price) *100) / element_compare_at_price).toFixed(0) +"%")); })
                              // "undefined" != typeof $saveAmountElement && $saveAmountElement.find("span.money").replaceWith(Mlveda.formatMoney((element_compare_at_price- element_price).toFixed(2), MCP_shop_money_format_with_span_money));
                              // "undefined" != typeof $salePercentage && "undefined" != typeof $salePercentage.html() && $salePercentage.html($salePercentage.html().replace(/\d{1,2}%/g,  "" +(((element_compare_at_price - element_price) *100) / element_compare_at_price).toFixed(0) +"%"));
                            }
                            else{
                              typeof $saleElement != 'undefined' && $saleElement.each((i, elem) => { $m(elem).find('.money').length == 0 && $m(elem).hide() })
                              typeof $saveAmountElement != 'undefined' && $saveAmountElement.each((i, elem) => { $m(elem).find('.money').length > 0 && $m(elem).hide() })
                              typeof $salePercentage != 'undefined' && $salePercentage.each((i, elem) => { $m(elem).find('.money').length == 0 && $m(elem).hide() })
                              // "undefined" != typeof $saleElement && $saleElement.find('.money').length == 0 && $saleElement.remove();
                              // "undefined" != typeof $saveAmountElement && $saveAmountElement.remove();
                              // "undefined" != typeof $salePercentage && $salePercentage.find('.money').length == 0 && $salePercentage.remove();
                              //isTextWithPrice && removeOtherText($mfirstMlvedamoney,textWithPrice);
                             removeOtherText($mfirstMlvedamoney,textWithPrice);
                            }
                        
                        
                          }
                          else {
                          var currentPrice = new RegExp('[,|\.]{1}[0-9]{2}$','g').test($msecondMlvedamoney.html().replace(/[^0-9 .,]/g,"").trim()) ? parseInt($msecondMlvedamoney.html().replace(/[^0-9]/g, ""),10)/100 : parseInt($msecondMlvedamoney.html().replace(/[^0-9]/g, ""),10);
                          var previousPrice = new RegExp('[,|\.]{1}[0-9]{2}$','g').test($mfirstMlvedamoney.html().replace(/[^0-9 .,]/g,"").trim()) ? parseInt($mfirstMlvedamoney.html().replace(/[^0-9]/g, ""),10)/100 : parseInt($mfirstMlvedamoney.html().replace(/[^0-9]/g, ""),10);                   
                        //var currentPrice = parseInt($msecondMlvedamoney.html().replace(/[^0-9]/g, ""),10);
                          //var previousPrice = parseInt($mfirstMlvedamoney.html().replace(/[^0-9]/g, ""),10);
                              if (currentPrice >= previousPrice ) {
                                if(!(element_compare_at_price) || parseFloat(element_compare_at_price) <= parseFloat(element_price)) {
                                  $mfirstMlvedamoney.html(Mlveda.formatMoney(element_price, MCP_shop_money_format));
                                  $msecondMlvedamoney.html("");
                        
                                  $mfirstMlvedamoney.removeAttributes();
                                  $mfirstMlvedamoney.addClass("money");
                        
                                  $msecondMlvedamoney.removeClass("money");
                                  // $mfirstMlvedamoney.each(function(){
                                  //   this.setAttribute("style", "color: " + priceColor + "!important");
                                  // })
                                  if( priceColor ==""){ a= $m(this).css('color') }
                              pcolor=priceColor==""?a:priceColor
                               $mfirstMlvedamoney.each(function(){
                                  this.setAttribute("style", "color: " + pcolor + "!important");
                                })
                        
                                  typeof $saleElement != 'undefined' && $saleElement.each((i, elem) => { $m(elem).find('.money').length == 0 && $m(elem).hide() })
                              typeof $saveAmountElement != 'undefined' && $saveAmountElement.each((i, elem) => { $m(elem).find('.money').length > 0 && $m(elem).hide() })
                              typeof $salePercentage != 'undefined' && $salePercentage.each((i, elem) => { $m(elem).find('.money').length == 0 && $m(elem).hide() })
                                  // "undefined" != typeof $saleElement && $saleElement.find('.money').length == 0 && $saleElement.remove();
                                  // "undefined" != typeof $saveAmountElement && $saveAmountElement.remove();
                                  // "undefined" != typeof $salePercentage && $salePercentage.find('.money').length == 0 && $salePercentage.remove();
                                  //isTextWithPrice && removeOtherText($mfirstMlvedamoney,textWithPrice);
                                  removeOtherText($mfirstMlvedamoney,textWithPrice);
                                } else {
                                  $msecondMlvedamoney.html(Mlveda.formatMoney(element_compare_at_price, MCP_shop_money_format));
                                  $mfirstMlvedamoney.html(Mlveda.formatMoney(element_price, MCP_shop_money_format));
                        
                                  $msecondMlvedamoney.removeAttributes();
                                  $msecondMlvedamoney.addClass("money");
                        
                                  $mfirstMlvedamoney.removeAttributes();
                                  $mfirstMlvedamoney.addClass("money");
                        
                                  $saveAmountElement.each((i, elem) => { $m(elem).find("span.money").replaceWith(Mlveda.formatMoney((element_compare_at_price- element_price).toFixed(2), MCP_shop_money_format_with_span_money)) })
                                  $salePercentage.each((i, elem) => { elem.innerHTML.length > 0 && $m(elem).html($salePercentage.html().replace(/\d{1,2}%/g,  "" +(((element_compare_at_price - element_price) *100) / element_compare_at_price).toFixed(0) +"%")); })
                                  // "undefined" != typeof $saveAmountElement && $saveAmountElement.find("span.money").replaceWith(Mlveda.formatMoney((element_compare_at_price- element_price).toFixed(2), MCP_shop_money_format_with_span_money));
                                   // "undefined" != typeof $salePercentage && "undefined" != typeof $salePercentage.html() && $salePercentage.html($salePercentage.html().replace(/\d{1,2}%/g,  "" +(((element_compare_at_price - element_price) *100) / element_compare_at_price).toFixed(0) +"%"));
                                }
                                }
                                else if( currentPrice < previousPrice ){
                                 
                                  if(!(element_compare_at_price) || parseFloat(element_compare_at_price) <= parseFloat(element_price)) {
                                    // if($mfirstMlvedamoney.parents('.price__regular:visible').length>0){
                                    //   [$mfirstMlvedamoney,$msecondMlvedamoney] = [$msecondMlvedamoney,$mfirstMlvedamoney]
                                    // }
                                    $msecondMlvedamoney.html(Mlveda.formatMoney(element_price, MCP_shop_money_format));
                                    $mfirstMlvedamoney.html("");
                        
                                    $msecondMlvedamoney.removeAttributes();
                                    $msecondMlvedamoney.addClass("money");
                        
                                    $mfirstMlvedamoney.removeClass("money");
                                    //$msecondMlvedamoney[0].setAttribute("style", "color: " + priceColor + "!important");
                                    if( priceColor ==""){ a= $m(this).css('color') }
                                    pcolor=priceColor==""?a:priceColor
                                    $msecondMlvedamoney.each(function(){
                                    this.setAttribute("style", "color: " + pcolor + "!important");
                                  })
                                    typeof $saleElement != 'undefined' && $saleElement.each((i, elem) => { $m(elem).find('.money').length == 0 && $m(elem).hide() })
                              typeof $saveAmountElement != 'undefined' && $saveAmountElement.each((i, elem) => { $m(elem).find('.money').length > 0 && $m(elem).hide() })
                              typeof $salePercentage != 'undefined' && $salePercentage.each((i, elem) => { $m(elem).find('.money').length == 0 && $m(elem).hide() })
                                    // "undefined" != typeof $saleElement && $saleElement.find('.money').length == 0 && $saleElement.remove();
                                    // "undefined" != typeof $saveAmountElement && $saveAmountElement.remove();
                                    // "undefined" != typeof $salePercentage && $salePercentage.find('.money').length == 0 && $salePercentage.remove();
                                    //isTextWithPrice && removeOtherText($msecondMlvedamoney,textWithPrice);
                                    removeOtherText($mfirstMlvedamoney,textWithPrice);
                                  } else {
                                    $mfirstMlvedamoney.html(Mlveda.formatMoney(element_compare_at_price, MCP_shop_money_format));
                                    $msecondMlvedamoney.html(Mlveda.formatMoney(element_price, MCP_shop_money_format));
                                       
                                    $mfirstMlvedamoney.removeAttributes();
                                    $mfirstMlvedamoney.addClass("money");
                        
                                    $msecondMlvedamoney.removeAttributes();
                                    $msecondMlvedamoney.addClass("money");   
                        
                                    $saveAmountElement.each((i, elem) => { $m(elem).find("span.money").replaceWith(Mlveda.formatMoney((element_compare_at_price- element_price).toFixed(2), MCP_shop_money_format_with_span_money)) })
                                    $salePercentage.each((i, elem) => { elem.innerHTML.length > 0 && $m(elem).html($salePercentage.html().replace(/\d{1,2}%/g,  "" +(((element_compare_at_price - element_price) *100) / element_compare_at_price).toFixed(0) +"%")); })
                                    //   "undefined" != typeof $saveAmountElement && $saveAmountElement.find("span.money").replaceWith(Mlveda.formatMoney((element_compare_at_price- element_price).toFixed(2), MCP_shop_money_format_with_span_money));
                                     // "undefined" != typeof $salePercentage && "undefined" != typeof $salePercentage.html() && $salePercentage.html($salePercentage.html().replace(/\d{1,2}%/g,  "" +(((element_compare_at_price - element_price) *100) / element_compare_at_price).toFixed(0) +"%"));                                
                                  }
                                }
                                
                               }
                          } else {
                        //             var $saleElement;
                        //             // if(isSaleClass){
                        //             //   $saleElement = findSaleDetails.call($m(this), saleClass);
                        //             //         }    
                        //             $saleElement = findSaleDetails.call($m(this), saleClass);
                        
                        //             var $saveAmountElement;
                        //             // if(isSaveAmount){
                        //             //   $saveAmountElement  = findSaleDetails.call($m(this),saveAmountClass);
                        //             // }
                        //             $saveAmountElement  = findSaleDetails.call($m(this),saveAmountClass);
                        
                        //             var $salePercentage;
                        //             // if(isSalePercentage){
                        //             //   $salePercentage = findSaleDetails.call($m(this), salePercentageClass);		
                        //             // }
                        //             $salePercentage = findSaleDetails.call($m(this), salePercentageClass);	
                            
                                            // typeof $saleElement != 'undefined' && $saleElement.each((i, elem) => { $m(elem).find('.money').length == 0 && $m(elem).hide() })
                              // typeof $saveAmountElement != 'undefined' && $saveAmountElement.each((i, elem) => { $m(elem).find('.money').length > 0 && $m(elem).hide() })
                              // typeof $salePercentage != 'undefined' && $salePercentage.each((i, elem) => { $m(elem).find('.money').length == 0 && $m(elem).hide() })
                           
                                                                                                                                  
                        }
                        }                                            
                        });
                              }
                        });
                                
                        //$m("<style type=\"text/css\">span.money{ display: inline;}</style>").appendTo("head");
                        //  isSaleClass && $m("<style type='text/css'>"+ saleClass +"{ visibility : visible; }</style>").appendTo("head");
                        //  isSaveAmount && $m("<style type='text/css'>"+ saveAmountClass +"{ visibility : visible; }</style>").appendTo("head");
                        //  isSalePercentage && $m("<style type='text/css'>"+ salePercentageClass +"{ visibility : visible; }</style>").appendTo("head");
                        // for ( let i = 0; i < saleClasses.split(',').length; i++ ) {
                        //   $m("<style type='text/css'>"+ saleClasses.split(',')[i]+"{ visibility : visible; }</style>").appendTo("head");
                        //  } 
                        $m("<style type='text/css'>"+ saleClasses+"{ visibility : visible; }</style>").appendTo("head");
                        mlvedaFlagCalled = true;
                        if(typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") {
                        mlvedaload();
                        }          
                        }
                        //mlvedaload();
                        },
                        error: function(xhr, textStatus, errorThrown) {
                        removeFrom();
                        //  isSaleClass && $m("<style type='text/css'>"+ saleClass +"{ visibility : visible; }</style>").appendTo("head");
                        //        isSaveAmount && $m("<style type='text/css'>"+ saveAmountClass +"{ visibility : visible; }</style>").appendTo("head");
                        // isSalePercentage && $m("<style type='text/css'>"+ salePercentageClass +"{ visibility : visible; }</style>").appendTo("head");
                        // for ( let i = 0; i < saleClasses.split(',').length; i++ ) {
                        //   $m("<style type='text/css'>"+ saleClasses.split(',')[i]+"{ visibility : visible; }</style>").appendTo("head");
                        //  }    
                        $m("<style type='text/css'>"+ saleClasses+"{ visibility : visible; }</style>").appendTo("head");
                        $m("<style type=\"text/css\">span.money{ display: inline; }</style>").appendTo("head");
                        mlvedaFlagCalled = true;
                        if(typeof ACSCurrency !== "undefined" && typeof ACSCurrency.moneyFormats !== "undefined") {
                        mlvedaload();
                        }          
                        }
                        });
                        }
                        
                        //checkShopifyFormatMoney();
                        
                        (function () {
                        
                        
                        const open = XMLHttpRequest.prototype.open;
                        
                        XMLHttpRequest.prototype.open = function(){
                        var url_before_ajax = arguments;
                        
                        if ( shopify_supported_currencies.length > 4 && window.location.href.indexOf('/cart') == -1 ) {
                        for(mysingleURL of appendStoreCurrency){
                        var singleURL = mysingleURL.trim();
                        if(singleURL.length >0 && "undefined"!= typeof url_before_ajax && url_before_ajax[1].indexOf("currency="+mlvedaShopCurrency) == -1 &&(url_before_ajax[1].indexOf(singleURL) != -1)){		
                        if(url_before_ajax[1].indexOf("&") != -1 || url_before_ajax[1].indexOf("?") != -1){
                        url_before_ajax[1] = url_before_ajax[1] + "&currency="+mlvedaShopCurrency;         	
                        }
                        else{
                        url_before_ajax[1] = url_before_ajax[1] + "?currency="+mlvedaShopCurrency;
                        }
                        }
                        }
                        }
                        
                        
                        
                        return open.apply(this,arguments);
                        }
                        
                        const send = XMLHttpRequest.prototype.send;
                        XMLHttpRequest.prototype.send = function() {
                        this.addEventListener('load', function() {
                        
                        if ( this.responseURL.indexOf("add.js")!=-1 || this.responseURL.indexOf("change.js")!=-1 || this.responseURL.indexOf("update.js")!=-1 || this.responseURL.indexOf("cart")!=-1 ) {
                        remove_mlveda()
                        }
                        
                        //       for(mysingleURL of myURLarray){
                        //         var singleURL = mysingleURL.trim();
                        // 	   	if(singleURL.length > 0 && "undefined" != typeof this.responseURL && (this.responseURL.indexOf(singleURL)!= -1 || (this.responseURL.indexOf("/search")!= -1 && this.responseURL.match(queryParameterRegex) == null))) {
                        //             setTimeout(function() {
                        //                  $m("<style type=\"text/css\">span.money{ display: none; }</style>").appendTo("head");
                        //                  checkShopifyFormatMoney();
                        //                 },300);
                        //         }
                        //       }
                        // add your global handler here
                        })
                        return send.apply(this, arguments)
                        }
                        
                        const fetch = window.fetch;
                        window.fetch = function(){
                        var e = arguments;
                        
                        if ( shopify_supported_currencies.length > 4 && window.location.href.indexOf('/cart') == -1 ) {
                        
                        for ( mysingleURL of appendStoreCurrency) {
                        var singleURL = mysingleURL.trim();
                        if( singleURL.length > 0 && "undefined"!= typeof arguments && arguments[0].indexOf("currency="+mlvedaShopCurrency) == -1 && arguments[0].indexOf(singleURL) != -1){		
                        if(arguments[0].indexOf("&") != -1 || arguments[0].indexOf("?") != -1){
                        arguments[0] = arguments[0] + "&currency="+mlvedaShopCurrency;         	
                        } else {
                        arguments[0] = arguments[0] + "?currency="+mlvedaShopCurrency;
                        }
                        }
                        }
                        
                        if(e[0].indexOf("checkouts.json")!=-1){
                        var newBODY = {...JSON.parse(e[1].body)};
                        if(newBODY.checkout.presentment_currency != ACSCurrency.currentCurrency){
                        newBODY.checkout.presentment_currency = ACSCurrency.currentCurrency;
                        }
                        arguments[1].body = JSON.stringify(newBODY);
                        }
                        }
                        
                        return fetch.apply(this, Array.prototype.slice.call(arguments)).then(function(t) {
                        if (!t.ok)
                        return t;
                        try {
                        
                        setTimeout( function() {
                        if ( t.url.indexOf("add.js")!=-1 || t.url.indexOf("change.js")!=-1 || t.url.indexOf("update.js")!=-1 || t.url.indexOf("cart")!=-1  ) {
                        remove_mlveda()
                        }
                        }, 300 )
                        
                        
                        //               for(mysingleURL of myURLarray){
                        //                 var singleURL = mysingleURL.trim();
                        //                   if(singleURL.length > 0 && "undefined" != typeof t.url && (t.url.indexOf(singleURL)!= -1 || (t.url.indexOf("/search")!= -1 && t.url.match(queryParameterRegex) == null))) {
                        //                       setTimeout(function() {
                        //                           $m("<style type=\"text/css\">span.money{ display: none; }</style>").appendTo("head");
                        //                           checkShopifyFormatMoney();
                        //                       },300);
                        //                   }
                        //               }
                        } catch (e) {
                        console && console.warn && console.warn("[shop_events_listener] Error in handleFetchRequest:  " + e.message);
                        }
                        return t
                        })
                        }
                        
                        })();